import Navigation from "../components/navigation";
import { useTheme } from "@mui/material/styles";
import UploadImages from "../components/uploadImages/index";

export default function UploadImagesRoute() {
  const theme = useTheme();
  return (
    <div style={{ marginLeft: theme.spacing(2) }}>
      <Navigation />
      <div style={{ paddingTop: 60 }}>
        <UploadImages />
      </div>
    </div>
  );
}
